// Volume-Dry units data for conversion routes
export const volumeDryUnits = [
  { id: 'liter', name: 'Liter', symbol: 'L', plural: 'Liters', factor: 1 },
  { id: 'us-bushel', name: 'US Bushel', symbol: 'bu', plural: 'US Bushels', factor: 35.2391 },
  { id: 'us-peck', name: 'US Peck', symbol: 'pk', plural: 'US Pecks', factor: 8.80977 },
  { id: 'us-dry-gallon', name: 'US Dry Gallon', symbol: 'dry gal', plural: 'US Dry Gallons', factor: 4.40488 },
  { id: 'us-dry-quart', name: 'US Dry Quart', symbol: 'dry qt', plural: 'US Dry Quarts', factor: 1.10122 },
  { id: 'us-dry-pint', name: 'US Dry Pint', symbol: 'dry pt', plural: 'US Dry Pints', factor: 0.55061 },
  { id: 'imperial-bushel', name: 'Imperial Bushel', symbol: 'bu (imp)', plural: 'Imperial Bushels', factor: 36.3687 },
  { id: 'imperial-peck', name: 'Imperial Peck', symbol: 'pk (imp)', plural: 'Imperial Pecks', factor: 9.09218 },
  { id: 'imperial-gallon', name: 'Imperial Gallon', symbol: 'gal', plural: 'Imperial Gallons', factor: 4.54609 },
  { id: 'imperial-quart', name: 'Imperial Quart', symbol: 'qt (imp)', plural: 'Imperial Quarts', factor: 1.13652 },
  { id: 'cubic-meter', name: 'Cubic Meter', symbol: 'm³', plural: 'Cubic Meters', factor: 1000 },
];

// Popular conversions matching common usage
export const popularVolumeDryConversions = [
  { from: 'us-bushel', to: 'liter' },
  { from: 'liter', to: 'us-bushel' },
  { from: 'us-bushel', to: 'imperial-bushel' },
  { from: 'imperial-bushel', to: 'us-bushel' },
  { from: 'us-peck', to: 'liter' },
  { from: 'liter', to: 'us-peck' },
  { from: 'us-bushel', to: 'us-peck' },
  { from: 'us-peck', to: 'us-bushel' },
  { from: 'us-dry-gallon', to: 'liter' },
  { from: 'liter', to: 'us-dry-gallon' },
  { from: 'imperial-gallon', to: 'liter' },
  { from: 'liter', to: 'imperial-gallon' },
  { from: 'us-bushel', to: 'cubic-meter' },
  { from: 'cubic-meter', to: 'us-bushel' },
  { from: 'imperial-bushel', to: 'liter' },
  { from: 'liter', to: 'imperial-bushel' },
  { from: 'us-dry-quart', to: 'liter' },
  { from: 'liter', to: 'us-dry-quart' },
  { from: 'imperial-peck', to: 'liter' },
  { from: 'liter', to: 'imperial-peck' },
  { from: 'imperial-quart', to: 'liter' },
  { from: 'liter', to: 'imperial-quart' },
  { from: 'us-dry-pint', to: 'liter' },
  { from: 'liter', to: 'us-dry-pint' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return volumeDryUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertVolumeDry = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to liters first, then to target unit
  const liters = value * fromUnit.factor;
  return liters / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertVolumeDry(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online volume-dry unit converter.`;
};
